import { render } from "./AIRecommendationsContent.vue?vue&type=template&id=0b322255&scoped=true"
import script from "./AIRecommendationsContent.vue?vue&type=script&lang=js"
export * from "./AIRecommendationsContent.vue?vue&type=script&lang=js"

import "./AIRecommendationsContent.vue?vue&type=style&index=0&id=0b322255&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b322255"]])

export default __exports__